module.exports = __webpack_public_path__ + "static/media/5.9821f736.jpg";